import { ArrowLeft, Sparkles } from 'lucide-react';
import { ShareWhatsAppButton } from './ShareWhatsAppButton';

const VendeConIaPage = () => {
  return (
    <div data-testid="vende-con-ia-page" className="min-h-screen bg-slate-100 flex flex-col">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-4">
          <a
            href="/"
            data-testid="back-home"
            className="flex items-center gap-2 text-slate-500 hover:text-[#1D1D1B] font-medium text-sm transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Regresar
          </a>
          <div className="w-px h-5 bg-slate-200" />
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <Sparkles className="h-4 w-4 text-[#45A0EE] flex-shrink-0" />
            <div className="min-w-0">
              <p className="font-bold text-[#1D1D1B] text-sm truncate">Vende con IA</p>
              <p className="text-slate-400 text-[10px] truncate">AI Funnel + Asistente IA — Club Viajemos / Travel Empire</p>
            </div>
          </div>
          <ShareWhatsAppButton docKey="vendeconia" />
        </div>
      </header>

      <div className="flex-1">
        <iframe
          src="/vendeconia.html"
          className="w-full border-0"
          style={{ minHeight: 'calc(100vh - 56px)', height: 'calc(100vh - 56px)' }}
          title="Vende con IA - Club Viajemos"
        />
      </div>
    </div>
  );
};

export default VendeConIaPage;
